import request from '@/api/request';

export function getGeofences () {
  return request({
    url: '/geofence',
    method: 'get',
  });
}

export function getGeofenceDetail (id) {
  return request({
    url: '/geofence/detail',
    method: 'get',
    params: {
      id
    }
  });
}

export function createGeofence (data) {
  return request({
    url: '/geofence',
    method: 'post',
    data
  });
}

export function updateGeofence (data) {
  return request({
    url: '/geofence',
    method: 'put',
    data
  });
}

export function deleteGeofence (data) {
  return request({
    url: '/geofence/delete',
    method: 'post',
    data
  });
}

export function addVehicleToGeofence (data) {
  return request({
    url: '/geofence/addvehicle',
    method: 'post',
    data
  });
}

export function googleGeocoding (address) {
  return request({
    url: '/geofence/googlegeocoding',
    method: 'get',
    params: {
      address
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/geofence.js